import RespinRecord from "model/respin-record";
import QuickfireIsRecoveryFreespinsSummary from "quickfire/states/quickfire-is-recovery-freespins-summary";
import gameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class SGIsRecoveryFreespinsSummary extends Decision {
    public evaluate() {
        const qfIsRecoverySummary = new QuickfireIsRecoveryFreespinsSummary().evaluate() === Exit.True;
        const record = gameState.getCurrentGame().getCurrentRecord();
        const wasWinSpin = record.id === "FreespinRecord";
        return qfIsRecoverySummary && wasWinSpin ? Exit.True : Exit.False;
    }
}
